"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodType = void 0;
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Card"] = "card";
    PaymentMethodType["ApplePay"] = "applePay";
    PaymentMethodType["GooglePay"] = "googlePay";
    PaymentMethodType["Venmo"] = "venmo";
    PaymentMethodType["PayPal"] = "payPal";
    PaymentMethodType["Unknown"] = "unknown";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
//# sourceMappingURL=paymentMethodType.js.map